// extracted by mini-css-extract-plugin
export default {"containerCard":"Item_containerCard__U-Ua7","card":"Item_card__vEIm7","info":"Item_info__Os5is"};